import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withStyles, Card, CardContent, CardMedia, Typography } from '@material-ui/core'
import * as utils from '../utils'
import * as actions from '../actions'
import Room from '@material-ui/icons/Room'
import houseIcon from '../images/svg/hut.svg'
import Favorite from 'features/favorites/components/Favorite'
import { addPropertyToFavorites, removePropertyFromFavorites } from '../actions'
import { CONTRACT, SOLD, ASSINGMENTS_LOCATION_LABEL } from '../constants'

const styles = {
  card: {
    minWidth: '290px',
    minHeight: '280px',
    maxWidth: '290px',
    maxHeight: '280px',
    boxShadow: '0 7px 23px 0 rgba(0, 0, 0, 0.04)',
    position: 'relative',
  },
  smallCard: {
    maxHeight: '92px',
    minHeight: '92px',
    display: 'flex',
  },
  smallMedia: {
    minWidth: '92px',
    maxWidth: '92px',
    minHeight: '92px',
    maxHeight: '92px',
    padding: '0 !important',
  },
  smallCardContent: {
    width: 'calc(100% - 92px)',
    padding: '10px',
    '& h1': {
      fontSize: '18px !important',
      lineHeight: 'normal !important',
      paddingBottom: '8px !Important',
      maxWidth: 'calc(100% - 39px)',
    },
    '& p': {
      fontSize: '14px !important',
    },
  },
  media: {
    height: 0,
    background: '#e5f8f7',
    cursor: 'pointer',
    paddingTop: '56.25%',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
  },
  truncate: {
    maxWidth: '100%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  newBadge: {
    width: '41px',
    height: '18px',
    borderRadius: '10px',
    backgroundColor: 'rgba(255, 210, 0, 0.72)',
    border: 'solid 1px #ffd200',
    fontSize: '10px',
    fontWeight: '500',
    lineHeight: '1.9',
    letterSpacing: '0.8px',
    color: 'rgba(0, 0, 0, 0.8)',
    position: 'absolute',
    textAlign: 'center',
    textTransform: 'uppercase',
  },
  badgeLeft: {
    top: '7px',
    left: '7px',
  },
  badgeRight: {
    right: '15px',
  },
  contentWrapper: {
    display: 'inline-block',
    width: '100%',
  },
  favIcon: {
    position: 'absolute',
    top: '10px',
    right: '10px',
  },
  propertyPrice: {
    fontSize: '22px',
    fontWeight: '500',
    color: '#333645',
    lineHeight: '0.93',
    paddingBottom: '10px',
  },
  propertySqft: {
    fontSize: '17px',
    fontWeight: 500,
    color: '#00bcb5',
    lineHeight: '0.93',
    paddingBottom: '7px',
  },
  paddingEqul: {
    padding: 5,
  },
  propertyView: {
    display: 'flex',
    alignItems: 'center',
    color: '#838383',
    fontSize: '15px',
  },
  propertyRoom: {
    color: '#fdd200',
    marginLeft: '-5px',
    marginRight: '5px',
  },
  placeholderImage: {
    backgroundSize: 'inherit',
  },
  cardTagContent: {
    position: 'static',
  },
  propertyTag: {
    display: 'inline-block',
    margin: '0',
    padding: '3px 5px',
    fontSize: '11px',
    fontWeight: '500',
    color: '#fff',
    borderRadius: '0',
    position: 'absolute',
    left: '0',
    top: '0',
  },
  newTag: {
    backgroundColor: '#d24c4c',
  },
  soldTag: {
    backgroundColor: '#2fae54',
  },
  underTag: {
    backgroundColor: '#e4ad5e',
  },
}

function PropertyCard(props) {
  const { classes, property, actions, noMap = false, largeCard = false, user, addPropertyToFavorites, removePropertyFromFavorites } = props
  const originalImage = property.defaultImage ? utils.thumbnailUrl(property.defaultImage) : ''
  const defaultImage = originalImage || houseIcon
  const cardClass = largeCard ? '' : classes.smallCard
  const imageClass = defaultImage === houseIcon ? classes.placeholderImage : ''
  return (
    <div
      className={classes.contentWrapper}
      onMouseEnter={() => {
        if (!noMap) actions.mapMarkerHover(parseInt(property.id, 10))
      }}
      onMouseLeave={() => {
        if (!noMap) actions.mapMarkerHover(null)
      }}>
      <Card className={`${classes.card} ${cardClass}`}>
        <CardMedia className={`${classes.media} ${largeCard ? '' : classes.smallMedia} ${imageClass}`} image={defaultImage} title={property.description} />
        <div className={classes.favIcon}>
          <Favorite
            addPropertyToFavorites={addPropertyToFavorites}
            removePropertyFromFavorites={removePropertyFromFavorites}
            propertyId={property.id}
            showFlashMessage={actions.showFlashMessage}
            user={user}
          />
        </div>
        <CardContent className={`${largeCard ? '' : classes.smallCardContent} ${classes.cardTagContent}`}>
          {property.sellerLeadStage && property.sellerLeadStage.toLowerCase() === SOLD ? (
            <span className={`${classes.propertyTag} ${classes.soldTag}`}>Sold</span>
          ) : property.sellerLeadStage && property.sellerLeadStage.toLowerCase() === CONTRACT ? (
            <span className={`${classes.propertyTag} ${classes.underTag}`}>Under Contract</span>
          ) : property.startListingOn && utils.isNewlyListedProperty(property.startListingOn) ? (
            <span className={`${classes.propertyTag} ${classes.newTag}`}>New</span>
          ) : (
            ''
          )}
          {/* {!cardPlacement && utils.isNewlyAddedProperty(property.createdAt) && <span className={`${classes.newBadge} ${classes.badgeRight}`}>new</span>} */}
          <Typography
            variant="headline"
            component="h1"
            className={
              property.sellerLeadStage && property.sellerLeadStage.toLowerCase() === SOLD
                ? `strike-through ${classes.truncate} ${classes.propertyPrice}`
                : `${classes.truncate} ${classes.propertyPrice}`
            }>
            {`$${utils.withCommas(property.price || 0)}`}
          </Typography>
          <Typography component="p" className={`${classes.truncate} ${classes.propertySqft}`}>
            {`${utils.withCommas(property.sqft || 0)} SQFT`}
            <span className={classes.paddingEqul}>&bull;</span>
            {property.beds || 0} BD
            <span className={classes.paddingEqul}>&bull;</span>
            {property.baths || 0} BA
          </Typography>
          <Typography className={classes.propertyView} component="p">
            <Room className={classes.propertyRoom} />{' '}
            <span className={classes.truncate}>
              {property.address && !(property.type && property.type.toLowerCase() === process.env.REACT_APP_ASSINGMENTS_PROPERTY_TYPE)
                ? `${property.address}, ${property.city}, ${property.state}`
                : `${ASSINGMENTS_LOCATION_LABEL}`}
            </span>
          </Typography>
        </CardContent>
      </Card>
    </div>
  )
}

PropertyCard.propTypes = {
  classes: PropTypes.object.isRequired,
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
    ...bindActionCreators({ addPropertyToFavorites, removePropertyFromFavorites }, dispatch),
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
  }
}

const propcard = connect(
  mapStateToProps,
  mapDispatchToProps
)(PropertyCard)

export default withStyles(styles)(propcard)



// WEBPACK FOOTER //
// ./src/components/PropertyCard.js